// removed by extract-text-webpack-plugin
module.exports = {"empty-container":"_3boH8PbLj3XRCF5OZNj2if","content":"_3IINjiCZV_NQRNdWYfWmNn","container":"_2A4kusYAWzgzmrC_BbSJ7a"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailTypeContent.less
 ** module id = 392
 ** module chunks = 0
 **/